const minorValue = (value, min) => {
    if (min === undefined) {
        return false;
    }
    const minorThanMin = Number(value) < Number(min);
    return minorThanMin;
};
const maxValue = (value, max) => {
    if (!max) {
        return false;
    }
    const higherThanMax = Number(value) > Number(max);
    return higherThanMax;
};
const maxLengthLimit = (value, maxLength) => {
    if (!maxLength) {
        return value;
    }
    let valueLimited = value;
    if (String(value).length > maxLength) {
        valueLimited = String(value).substring(0, String(value).length - (String(value).length - maxLength));
    }
    return valueLimited;
};
export const limitValue = (value, min, max, maxLength) => {
    let limit = value;
    const minorThanMin = minorValue(value, min);
    const higherThanMax = maxValue(value, max);
    if (min !== undefined && minorThanMin) {
        limit = min;
    }
    else if (max && higherThanMax) {
        limit = max;
    }
    const limited = maxLengthLimit(limit, maxLength);
    return limited;
};
//# sourceMappingURL=limitValue.js.map